export const ParentColumnPlacement = {
  Left: 1,
  Center: 2,
  Right: 3,
};

export const DefaultSortDirection = {
  Ascending: 'asc',
  Descending: 'desc',
};
